import objectPath from "object-path";
import merge from "deepmerge";
import config from "@/core/config/layout.config.json";

// action types
export const SET_LAYOUT_CONFIG = "setLayoutConfig";
export const RESET_LAYOUT_CONFIG = "resetLayoutConfig";
export const OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig";
export const OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig";
export const SET_PAGE_LOADING = "setPageLoading";
export const SET_IMPORT_REPORT_DIALOG = "setImportReportDialog";
export const SET_IMPORT_REPORT_DATA = "setImportReportData";
export const SET_REPORT_MODAL_DATA = "setReportModalData";
export const SET_REPORT_MODAL_STATE = "setReportModalState";

// mutation types

export default {
  state: {
    config: config,
    initial: config,
    page_loading: true,
    error: {},
    importReportData: null,
    importReportDialog: false,
    reportModalData: {},
    reportModalState: false,
  },
  getters: {
    getReportModalState(state) {
      return state.reportModalState;
    },
    getReportModalData(state) {
      return state.reportModalData;
    },
    getImportReportDialog(state) {
      return state.importReportDialog;
    },
    getImportReportData(state) {
      return state.importReportData;
    },
    /**
     * Get config from layout config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    layoutConfig: (state) => (path, defaultValue) => {
      return objectPath.get(state.config, path, defaultValue);
    },
    getPageLoading(state) {
      return state.page_loading;
    },
  },
  actions: {
    /**
     * Set and replace the whole config
     * @param state
     * @param payload
     */
    [SET_LAYOUT_CONFIG](state, payload) {
      state.commit(SET_LAYOUT_CONFIG, payload);
    },

    /**
     * Reset the config at the initial state
     * @param state
     */
    [RESET_LAYOUT_CONFIG](state) {
      state.commit(RESET_LAYOUT_CONFIG);
    },

    /**
     * Reset the config using saved config in the cache by the layout builder
     * @param state
     */
    // [OVERRIDE_LAYOUT_CONFIG](state) {
    //   state.commit(OVERRIDE_LAYOUT_CONFIG);
    // },

    /**
     * Override config by page level
     * @param state
     * @param payload
     */
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
      state.commit(OVERRIDE_PAGE_LAYOUT_CONFIG, payload);
    },
  },
  mutations: {
    [SET_REPORT_MODAL_STATE](state, status) {
      state.reportModalState = status;
    },
    [SET_REPORT_MODAL_DATA](state, data) {
      state.reportModalData = data;
    },
    [SET_IMPORT_REPORT_DIALOG](state, status) {
      state.importReportDialog = status;
    },
    [SET_IMPORT_REPORT_DATA](state, data) {
      state.importReportData = data;
    },
    [SET_PAGE_LOADING](state, loading_state) {
      state.page_loading = loading_state;
    },
    [SET_LAYOUT_CONFIG](state, payload) {
      state.config = payload;
    },
    [RESET_LAYOUT_CONFIG](state) {
      state.config = Object.assign({}, state.initial);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.config = state.initial = Object.assign(
        {},
        state.initial,
        JSON.parse(localStorage.getItem("config"))
      );
    },
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
      state.config = merge(state.config, payload);
    },
  },
};
